export var alignments = {
  left: 'left',
  right: 'right'
};
export var alignmentsArray = Object.values(alignments);